module.exports = __webpack_public_path__ + "img/headphones.ea669b0a.svg";